var ɵ0 = { preload: true, delay: false }, ɵ1 = { preload: true, delay: false }, ɵ2 = { preload: true, delay: false }, ɵ3 = { preload: true, delay: true }, ɵ4 = { preload: true, delay: true }, ɵ5 = { preload: true, delay: true }, ɵ6 = { preload: true, delay: true };
var OrderRouteModule = /** @class */ (function () {
    function OrderRouteModule() {
    }
    return OrderRouteModule;
}());
export { OrderRouteModule };
export { ɵ0, ɵ1, ɵ2, ɵ3, ɵ4, ɵ5, ɵ6 };
